import './src/locales/i18n'

export const onClientEntry = () => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log("✅ Service Worker registriert:", registration);
      })
      .catch((err) => {
        console.error("❌ Service Worker Registrierung fehlgeschlagen:", err);
      });
  }
};